import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import { AddCodesPage } from '../../Pages/Products/AddCodes';
import { AddCodesList } from '../../Pages/Products/AddCodesList';
import { AddProductPage } from '../../Pages/Products/AddProduct';
import { EditProductPage } from '../../Pages/Products/EditProduct';
import { ProductsList } from '../../Pages/Products/ProductsList';
import MerchantsLayout from '../../layout/layouts/MerchantsLayout';
import { resources } from '../../resources/resources';

export const ProductsRoutes = () => {
  const { t: translate } = useTranslation();
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WithTabTitle title={translate(resources.products.list.title)}>
            <MerchantsLayout>
              <ProductsList />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/codes"
        element={
          <WithTabTitle title={translate(resources.products.list.codes.title)}>
            <MerchantsLayout>
              <AddCodesList />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/add"
        element={
          <WithTabTitle title={translate(resources.menu.products.addProduct)}>
            <MerchantsLayout>
              <AddProductPage />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/edit/:productId"
        element={
          <WithTabTitle title={translate(resources.menu.products.addCodes)}>
            <MerchantsLayout>
              <EditProductPage />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/add/codes/:productId"
        element={
          <WithTabTitle title={translate(resources.menu.products.addCodes)}>
            <MerchantsLayout>
              <AddCodesPage />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
    </Routes>
  );
};
